import axiosIns from '@/libs/axios'

const ROOT_URL = '/ReportPortal/dashboard'

export default {
  namespaced: true,
  state: {
    cacheInfo: [],
    loadings: {
      counters: false,
      monthlyInsurances: false,
      ytdNonAutomotive: false,
      earnCompanies: false,
      ytdRenewals: false,
      brandInsuranceRates: false,
      salePerformance: false,
    },
    dashboardData: {
      counters: {
        ytdPoliceAdet: 0,
        ytdKomisyon: {
          amount: 0,
          rates: 0,
        },
        ytdNetPrim: 0,
        ytdRenewals: {
          counts: 0,
          rates: 0,
        },
        mtdPoliceAdet: 0,
        mtdKomisyon: {
          amount: 0,
          rates: 0,
        },
        mtdNetPrim: 0,
        mtdRenewals: {
          counts: 0,
          rates: 0,
        },
      },
      monthlyInsurances: {
        series: [],
        categories: [],
      },
      ytdNonAutomotive: {
        series: [],
        labels: [],
        colors: [],
        rates: {
          automotive: {
            count: 0,
            rates: 0,
          },
          nonAutomotive: {
            count: 0,
            rates: 0,
          },
        },
      },
      earnCompanies: {
        series: [],
        categories: [],
      },
      ytdRenewals: {
        series: [],
        categories: [],
        colors: [],
      },
      brandInsuranceRates: {
        series: [],
        categories: [],
        colors: [],
      },
      salePerformance: {
        data: [],
        grandTotals: {
          salesCountTotal: 0,
          i2SalesCountTotal: 0,
          grandCountTotals: 0,
          salesAmountTotal: 0,
          i2SalesAmountTotal: 0,
          grandAmountTotals: 0,
        },
      },
    },
  },
  getters: {
    cacheInfo(state) {
      return state.cacheInfo
    },
    loadings(state) {
      return state.loadings
    },
    dashboardData(state) {
      return state.dashboardData
    },
  },
  mutations: {
    SET_LOADINGS(state, data) {
      if (data.type === 'counters') {
        state.loadings.counters = data.status
      }
      if (data.type === 'monthlyInsurances') {
        state.loadings.monthlyInsurances = data.status
      }
      if (data.type === 'ytdNonAutomotive') {
        state.loadings.ytdNonAutomotive = data.status
      }
      if (data.type === 'earnCompanies') {
        state.loadings.earnCompanies = data.status
      }
      if (data.type === 'ytdRenewals') {
        state.loadings.ytdRenewals = data.status
      }
      if (data.type === 'brandInsuranceRates') {
        state.loadings.brandInsuranceRates = data.status
      }
      if (data.type === 'salePerformance') {
        state.loadings.salePerformance = data.status
      }
    },

    SET_DASHBOARD_DATA(state, data) {
      if (data.type === 'counters') {
        state.dashboardData.counters = data.data
      }
      if (data.type === 'monthlyInsurances') {
        state.dashboardData.monthlyInsurances = data.data
      }
      if (data.type === 'ytdNonAutomotive') {
        state.dashboardData.ytdNonAutomotive = data.data
      }
      if (data.type === 'earnCompanies') {
        state.dashboardData.earnCompanies = data.data
      }
      if (data.type === 'ytdRenewals') {
        state.dashboardData.ytdRenewals = data.data
      }
      if (data.type === 'brandInsuranceRates') {
        state.dashboardData.brandInsuranceRates = data.data
      }
      if (data.type === 'salePerformance') {
        state.dashboardData.salePerformance = data.data
      }
    },
    SET_CACHE_INFO(state, data) {
      state.cacheInfo = data
    },
    /* RESET MUTATIONS */
    RESET_DASHBOARD_DATA(state) {
      state.dashboardData = {
        counters: {
          ytdPoliceAdet: 0,
          ytdKomisyon: {
            amount: 0,
            rates: 0,
          },
          ytdNetPrim: 0,
          ytdRenewals: {
            counts: 0,
            rates: 0,
          },
          mtdPoliceAdet: 0,
          mtdKomisyon: {
            amount: 0,
            rates: 0,
          },
          mtdNetPrim: 0,
          mtdRenewals: {
            counts: 0,
            rates: 0,
          },
        },
        monthlyInsurances: {
          series: [],
          categories: [],
        },
        ytdNonAutomotive: {
          series: [],
          labels: [],
          colors: [],
        },
        earnCompanies: {
          series: [],
          categories: [],
        },
        ytdRenewals: {
          series: [],
          categories: [],
          colors: [],
        },
        brandInsuranceRates: {
          series: [],
          categories: [],
          colors: [],
        },
        salePerformance: {
          data: [],
          grandTotals: {
            salesCountTotal: 0,
            i2SalesCountTotal: 0,
            grandCountTotals: 0,
            salesAmountTotal: 0,
            i2SalesAmountTotal: 0,
            grandAmountTotals: 0,
          },
        },
      }
    },
  },
  actions: {
    getData({ commit }, params) {
      commit('SET_LOADINGS', { type: params.type, status: true })
      const data = JSON.stringify(params)
      axiosIns
        .post(`${ROOT_URL}/insurancesLive?type=${params.type}`, data)
        .then(response => {
          commit('SET_DASHBOARD_DATA', {
            type: params.type,
            data: response.data.data,
          })
          commit('SET_CACHE_INFO', response.data.cacheInfo)
          commit('SET_LOADINGS', { type: params.type, status: false })
        })
        .catch(error => console.error(error))
    },
    refreshData({ commit }, params) {
      commit('SET_LOADINGS', { type: params.type, status: true })
      const data = JSON.stringify(params)
      axiosIns
        .post(`${ROOT_URL}/insurancesLive?type=${params.type}&noCache=true`, data)
        .then(response => {
          commit('SET_DASHBOARD_DATA', {
            type: params.type,
            data: response.data.data,
          })
          commit('SET_CACHE_INFO', response.data.cacheInfo)
          commit('SET_LOADINGS', { type: params.type, status: false })
        })
        .catch(error => console.error(error))
    },
  },
}
